import { IStyles } from '@interfaces/styles';
import { useTheme } from '@mui/material';
import { ScreenSizes } from '@interfaces';

export const useStyles = (): IStyles => {
  const { breakpoints } = useTheme();

  return {
    root: {
      '> .MuiBox-root': {
        [breakpoints.up(ScreenSizes.TabletHorizontal)]: {
          padding: '64px 72px',
          width: '670px',

          '.MuiTypography-root': {
            fontSize: '16px',

            '&:first-of-type': {
              fontSize: '32px',
            },
          },
        },

        '.MuiTypography-root:last-of-type': {
          textAlign: 'justify',
          textAlignLast: 'center',
        },
      },
    },
  };
};
